/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const MoonStar = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" }],
    ["path", { d: "M19 3v4" }],
    ["path", { d: "M21 5h-4" }]
  ]
];

export { MoonStar as default };
//# sourceMappingURL=moon-star.js.map
